import { render, staticRenderFns } from "./ManufacturerProductPerformanceState.vue?vue&type=template&id=f520ad3c&"
import script from "./ManufacturerProductPerformanceState.vue?vue&type=script&lang=js&"
export * from "./ManufacturerProductPerformanceState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports